module.exports = __webpack_public_path__ + "static/media/conference-catering-1.44959e1f.jpg";